import { ListSubheader } from '@mui/material';
import { ListSubheaderProps } from '@mui/material/ListSubheader/ListSubheader';

import styles from './styles.module.scss';

export const ListSubheaderStyled = (props: ListSubheaderProps) => {
  return (
    <ListSubheader
      {...props}
      classes={{
        root: styles.root,
      }}
    />
  );
};
